import getColor from "@insite/mobius/utilities/getColor";
import { viewSelectStyles as styles } from "@solveindustrial/Overrides/Widgets/ProductList/ProductListViewSelect";
import { colorStrings } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.wrapper = {
    ...styles.wrapper,
    css: css`
        ${styles.wrapper?.css}
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
    `,
};

styles.gridViewClickable = {
    ...styles.gridViewClickable,
    css: css`
        ${styles.gridViewClickable?.css}
        margin: 0;
        &[data-test-selector="viewSelectTable"] {
            display: none;
        }
    `,
};

styles.listViewClickable = {
    ...styles.listViewClickable,
    css: css`
        ${styles.listViewClickable?.css}
        margin: 0;
    `,
};

styles.gridViewIcon = {
    ...styles.gridViewIcon,
    size: 16,
    
};

styles.listViewIcon = {
    ...styles.listViewIcon,
    size: 16,
};
